import { Preview } from "@creatomate/preview";
import { Subtitle } from "chq";
import readVttSections from "./readVttSections";

const readVttFile = async (
  newSubtitle: Subtitle,
  organizationName: string,
  preview: Preview,
  language: string,
  isNewSubtitle = true,
  undoPoint = false
): Promise<void> => {
  const response = await fetch(newSubtitle.url);
  const text = await response.text();

  const subtitle = { ...newSubtitle, text };

  // loadSubtitleSections method goes here
  await readVttSections(
    subtitle,
    true,
    preview,
    organizationName,
    language,
    isNewSubtitle,
    undoPoint
  );
};

export default readVttFile;
